import {
  AttachOutlineLegacy,
  Bold,
  Code,
  Italic,
  Link2Outline,
  List,
  ListOutline,
  Strikethrough,
  Underline,
} from '@lyearn/icons';
import {
  Bold as BoldMark,
  CodeInline as CodeInlineMark,
  EditorLink as EditorLinkMark,
  InlineEditorBulletList,
  InlineEditorOrderedList,
  Italic as ItalicMark,
  Strikethrough as StrikethroughMark,
  Underline as UnderlineMark,
} from '@/lygo/InstructionEditor';

import AttachOption from './components/AttachOption';
import MarkOption from './components/MarkOption';
import { EditorOptionType, ToolbarOption } from './types';
import { EditorOption, MarkState } from './types';

const boldMark = new BoldMark();
const italicMark = new ItalicMark();
const underlineMark = new UnderlineMark();
const strikethroughMark = new StrikethroughMark();
const inlineEditorOrderedList = new InlineEditorOrderedList();
const inlineEditorBulletList = new InlineEditorBulletList();
const codeInlineMark = new CodeInlineMark();
export const editorLinkMark = new EditorLinkMark();

export const defaultEditorOption = [
  ToolbarOption.Bold,
  ToolbarOption.Italic,
  ToolbarOption.Underline,
  ToolbarOption.Strikethrough,
  ToolbarOption.Separator,
  ToolbarOption.NumberedList,
  ToolbarOption.BulletList,
  ToolbarOption.Code,
  ToolbarOption.Link,
];

export const defaultAttachmentEditorOption = [
  ToolbarOption.Bold,
  ToolbarOption.Italic,
  ToolbarOption.Underline,
  ToolbarOption.Strikethrough,
  ToolbarOption.Separator,
  ToolbarOption.NumberedList,
  ToolbarOption.BulletList,
  ToolbarOption.Code,
  ToolbarOption.Separator,
  ToolbarOption.AttachFile,
  ToolbarOption.Link,
];

export const marks = [
  boldMark.name,
  italicMark.name,
  underlineMark.name,
  strikethroughMark.name,
  editorLinkMark.name,
  codeInlineMark.name,
];

export const MARK_DEFAULT_STATE = {
  [boldMark.name]: MarkState.Inactive,
  [italicMark.name]: MarkState.Inactive,
  [underlineMark.name]: MarkState.Inactive,
  [strikethroughMark.name]: MarkState.Inactive,
  [editorLinkMark.name]: MarkState.Hidden,
  [codeInlineMark.name]: MarkState.Inactive,
};

export const EditorOptionMap: Map<ToolbarOption, EditorOptionType> = new Map([
  [
    ToolbarOption.Bold,
    {
      Component: MarkOption,
      key: 'Tooltip_Bold',
      Icon: Bold,
      blockName: boldMark.name,
      className: 'me-2',
      editorOption: EditorOption.Mark,
      tooltipKey: 'Common:Tooltips.Bold',
    },
  ],
  [
    ToolbarOption.Italic,
    {
      Component: MarkOption,
      key: 'Tooltip_Italics',
      Icon: Italic,
      blockName: italicMark.name,
      editorOption: EditorOption.Mark,
      tooltipKey: 'Common:Tooltips.Italics',
    },
  ],
  [
    ToolbarOption.Underline,
    {
      Component: MarkOption,
      key: 'Tooltip_Underline',
      Icon: Underline,
      blockName: underlineMark.name,
      editorOption: EditorOption.Mark,
      tooltipKey: 'Common:Tooltips.Underline',
    },
  ],
  [
    ToolbarOption.Strikethrough,
    {
      Component: MarkOption,
      key: 'Tooltip_Strikethrough',
      Icon: Strikethrough,
      blockName: strikethroughMark.name,
      editorOption: EditorOption.Mark,
      tooltipKey: 'Common:Tooltips.Strikethrough',
    },
  ],
  [
    ToolbarOption.Link,
    {
      Component: MarkOption,
      key: 'Tooltip_Link',
      Icon: Link2Outline,
      blockName: editorLinkMark.name,
      editorOption: EditorOption.Mark,
      tooltipKey: 'Common:Tooltips.Link',
    },
  ],
  [
    ToolbarOption.Code,
    {
      Component: MarkOption,
      key: 'Tooltip_Code',
      Icon: Code,
      blockName: codeInlineMark.name,
      editorOption: EditorOption.Mark,
      tooltipKey: 'Common:Tooltips.Code',
    },
  ],
  [
    ToolbarOption.NumberedList,
    {
      Component: MarkOption,
      key: 'Tooltip_NumberedList',
      Icon: List,
      blockName: inlineEditorOrderedList.name,
      editorOption: EditorOption.List,
      tooltipKey: 'Common:Tooltips.NumberedList',
    },
  ],
  [
    ToolbarOption.BulletList,
    {
      Component: MarkOption,
      key: 'Tooltip_BulletList',
      Icon: ListOutline,
      blockName: inlineEditorBulletList.name,
      editorOption: EditorOption.List,
      tooltipKey: 'Common:Tooltips.BulletedList',
    },
  ],
  [
    ToolbarOption.AttachFile,
    {
      Component: AttachOption,
      key: 'Tooltip_AttachFile',
      blockName: 'add_file',
      Icon: AttachOutlineLegacy,
      tooltipKey: 'Common:Tooltips.AddFile',
    },
  ],
  [
    ToolbarOption.AttachMedia,
    {
      Component: AttachOption,
      key: 'Tooltip_AttachFile',
      blockName: 'add_file',
      Icon: AttachOutlineLegacy,
      tooltipKey: 'Common:Tooltips.AddMedia',
      accept: 'image/*, video/*',
    },
  ],
]);
